"use client";

import { useEffect, useState } from "react";
import { ChevronDown, Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function () {
  const headline = "The mighty oak from the little acorn grows.";
  const words = headline.split(" ");
  const [visibleChars, setVisibleChars] = useState(0);
  const totalChars = headline.length;
  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleChars(prev => {
        if (prev >= totalChars) {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, 30);
    return () => clearInterval(interval);
  }, [totalChars]);
  const tickerKeywords = ["EST. 2005", "NORTH YORK", "AGES 2.5 - 6", "MONTESSORI", "COMMUNITY", "PARKWOODS", "GROWTH", "DISCOVERY"];
  let charCount = 0;
  return <section data-section-id="531" id="the-mighty-oak-journey" className="relative w-full min-h-[800px] h-screen overflow-hidden bg-background text-foreground dark">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722029/img/classroom_discovery.png" alt="Children engaged in Montessori learning activities" className="w-full h-full object-cover" />
        {}
        <div className="absolute inset-0 bg-primary/40" />
        {}
        <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
        backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 2px, hsla(145, 30%, 12%, 0.3) 2px, hsla(145, 30%, 12%, 0.3) 3px)"
      }} />
        {}
        <div className="absolute inset-0 opacity-[0.08] pointer-events-none mix-blend-overlay" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.8'/%3E%3C/svg%3E\")"
      }} />
      </div>

      {}
      <div className="relative z-10 h-full min-h-[800px] grid grid-cols-12 gap-4 px-6 md:px-10 py-24 md:py-24">
        {}
        <div className="col-span-12 md:col-start-2 md:col-span-10 absolute top-24 left-6 md:left-10">
          <div className="flex items-center gap-3 font-mono text-xs md:text-sm text-accent tracking-wider">
            <span className="inline-block w-8 h-px bg-accent" />
            LITTLE ACORNS MONTESSORI
         </div>
        </div>

        {}
        <div className="col-span-12 md:col-start-2 md:col-span-10 flex flex-col justify-center mt-16 md:mt-12">
          {}
          <h1 className="font-default font-sans font-semibold leading-[1.1] tracking-tight text-white" style={{
          fontSize: "clamp(3rem, 9vw, 9rem)"
        }}>
            {words.map((word, wIdx) => {
            const isGrows = word === "grows.";
            const wordStart = charCount;
            const wordEnd = charCount + word.length;
            charCount = wordEnd + 1;
            return <span key={wIdx} data-index={wIdx} className="inline-block mr-[0.25em]">
                  {word.split("").map((char, cIdx) => {
                const absIdx = wordStart + cIdx;
                const visible = absIdx < visibleChars;
                return <span key={cIdx} className={`inline-block transition-all duration-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} ${isGrows ? "text-accent font-serif italic relative" : ""}`}>
                        {char}
                      </span>;
              })}
                </span>;
          })}
          </h1>

          {}
          <p className="mt-8 md:mt-10 max-w-3xl text-base md:text-xl lg:text-[22px] font-default text-white/90 leading-relaxed">
            Providing a nurturing, authentic Montessori environment in Parkwoods-Donalda since 2005. We cultivate curiosity and independence in every child.
          </p>

          {}
          <div className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="h-14 px-8 font-default text-sm tracking-wide uppercase bg-accent text-primary rounded-lg hover:bg-white transition-all">
              <Link to="/FeesEnrollmentPage">Book a Tour</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="h-14 px-8 font-default text-sm tracking-wide uppercase bg-transparent border-white/40 text-white rounded-lg hover:bg-white/10 hover:text-white transition-all">
              <Link to="/FeesEnrollmentPage">
                <Play className="size-3.5 mr-2" />
                Apply Now
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="hidden md:block absolute bottom-16 right-10 lg:right-16 col-span-3">
          <div className="border border-white/20 bg-primary/60 backdrop-blur-sm p-5 max-w-xs rounded-3xl">
            <div className="flex items-center gap-2 mb-3">
              <span className="relative flex size-2">
                <span className="absolute inline-flex h-full w-full rounded-lg bg-accent opacity-75 animate-ping" />
                <span className="relative inline-flex size-2 rounded-lg bg-accent" />
              </span>
              <span className="font-mono text-[10px] tracking-widest text-accent">
                [ENROLLMENT OPEN]
              </span>
            </div>
            <p className="font-default text-sm text-white leading-relaxed">
              Join our community of learners. Limited spots available for the upcoming academic year.
            </p>
            <div className="mt-3 pt-3 border-t border-white/10 flex items-center justify-between font-mono text-[10px] text-white/60">
              <span>AGES 2.5-6</span>
              <span>1:8 RATIO</span>
            </div>
          </div>
        </div>

        {}
        <div className="hidden md:flex absolute bottom-16 left-10 flex-col items-center gap-3">
          <span className="font-mono text-[10px] tracking-[0.3em] text-white/60 [writing-mode:vertical-rl] rotate-180">
            SCROLL
          </span>
          <div className="relative h-16 w-px bg-white/20 overflow-hidden">
            <div className="absolute inset-x-0 top-0 h-6 bg-accent animate-[scrollLine_2s_ease-in-out_infinite]" />
          </div>
          <ChevronDown className="size-3 text-white/60" />
        </div>

        {}
        <div className="hidden lg:flex absolute right-6 top-0 bottom-0 w-8 items-center justify-center overflow-hidden pointer-events-none">
          <div className="flex flex-col gap-12 animate-[tickerUp_30s_linear_infinite] [writing-mode:vertical-rl] rotate-180">
            {[...tickerKeywords, ...tickerKeywords].map((kw, i) => <span key={i} data-index={i} className="font-mono text-[10px] tracking-[0.4em] text-white/30 whitespace-nowrap">
                {kw} •
              </span>)}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(400%); }
        }
        @keyframes tickerUp {
          0% { transform: translateY(0) rotate(180deg); }
          100% { transform: translateY(-50%) rotate(180deg); }
        }
      `}</style>
    </section>;
}